module.exports = __webpack_public_path__ + "static/media/check.60b6f3c4.svg";